<template>
  <base-modal ref="deleteModal">
    <base-card shadow>
      <div class="sm:tw-flex sm:tw-items-start">
        <div class="tw-mx-auto tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center tw-h-12 tw-w-12 tw-rounded-full tw-bg-red-100 sm:tw-mx-0 sm:tw-h-10 sm:tw-w-10">
          <trash-icon class="tw-h-6 tw-w-6 tw-text-red-600" />
        </div>
        <div class="tw-mt-3 tw-text-center sm:tw-mt-0 sm:tw-ml-4 sm:tw-text-left">
          <h3 class="tw-text-xl tw-font-thin">Delete Training</h3>
          <div class="tw-mt-2">
            <p class="tw-font-thin tw-text-gray-600">Are you sure you want to delete {{ name }}?</p>
          </div>
        </div>
      </div>
      <div class="sm:tw-flex sm:tw-flex-row-reverse tw-mt-4">
        <base-button @click="deleteTraining()" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3" color="red">Confirm</base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0" color="red">
          Cancel
        </base-button>
      </div>
      <inline-error id="delete-training-modal-error" :title="errorTitle" :message="errorMessage" :error="error" />
    </base-card>
  </base-modal>
</template>
<script>
import { TrashIcon } from "@/assets/svgs";
import InlineError from "@/components/InlineError";

export default {
  name: "DeleteTraining",
  components: {
    TrashIcon,
    InlineError,
  },
  props: {
    businessId: String,
    trainingId: String,
    name: String,
  },
  data() {
    return {
      isLoading: false,
      errorTitle: "",
      errorMessage: "",
      error: null,
    };
  },
  methods: {
    deleteTraining() {
      this.isLoading = true;

      this.$axios
        .delete(`/businesses/${this.businessId}/trainings/${this.trainingId}`)
        .then(() => {
          this.$emit("deleted");
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Training Deleted", message: `Training ${this.name} was deleted successfully.` });
          this.hide();
        })
        .catch((err) => {
          this.errorTitle = `Failed to delete ${this.name}`;
          this.errorMessage = `Training ${this.name} was not able to be deleted. Please try again.`;
          this.error = err;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    show() {
      this.$refs.deleteModal.show();
    },
    hide() {
      this.$refs.deleteModal.hide();
    },
  },
};
</script>
